import React from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import cx from 'classnames';

import styles from './article.module.sass';
import constants from '../../../utils/constants';

const Article = ({ children, html, className }) => {
  const parseText = (content) => {
    return content.replace(/~([A-Za-z]+)~/g, (match, key) => {
      const value = constants[key];
      if (typeof value !== 'undefined') {
        return value;
      }
      return match;
    });
  };

  const replace = (domNode) => {
    if (
      domNode.name === 'a' &&
      domNode.attribs.href &&
      !['/', '#'].includes(domNode.attribs.href.charAt(0)) &&
      !domNode.attribs.href.startsWith('mailto:') &&
      !domNode.attribs.href.startsWith('tel:') &&
      domNode.attribs.href.indexOf('kservicing.com') === -1
    ) {
      return React.cloneElement(
        domToReact([domNode]),
        { target: '_blank' },
        domToReact(domNode.children),
      );
    }
    return true;
  };

  return (
    <article className={cx(styles.article, className)}>
      {children}
      {html && parse(parseText(html), { replace, trim: true })}
    </article>
  );
};

Article.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  html: PropTypes.string,
  className: PropTypes.string,
};

Article.defaultProps = {
  children: null,
  html: '',
  className: '',
};

export default Article;
